import { normalizePlatformLogoKey, resolveStaticPlatformLogo } from '@/shared/ui/logo'

export interface WeeklyMetricLogo {
  key: string
  src: string
}

export function resolveWeeklyMetricLogo(input: {
  logoKey?: unknown
  platform?: unknown
  metricKey?: unknown
}): WeeklyMetricLogo | null {
  for (const candidate of [input.logoKey, input.platform, input.metricKey]) {
    const key = normalizePlatformLogoKey(candidate)
    const src = resolveStaticPlatformLogo(key)
    if (src) return { key, src }
  }
  return null
}
